document.addEventListener("DOMContentLoaded", function() {
  var viewerContainers = document.querySelectorAll('.sketchfab-viewer-container');

  viewerContainers.forEach(function(container) {
    var iframeId = container.getAttribute('data-iframe-id');
    var iframe = document.getElementById(iframeId);
    var version = '1.12.1';
    var client = new Sketchfab(version, iframe);
    var uid = container.getAttribute('data-uid') || 'defaultUID';

    client.init(uid, {
      autostart: 1,
      autospin: 0.2,
      ui_annotations: 0,
      ui_general_controls: 1,
      ui_inspector: 0,
      ui_infos: 0,
      ui_watermark: 0,
      ui_stop: 0,
      ui_ar_help: 0,
      ui_settings: 0 // Hides the gear (settings) icon
    }, function(err, api) {
      if (!err) {
        console.log("Sketchfab API success for", iframeId);
        api.start();
        api.addEventListener('viewerready', function() {
          console.log('Viewer is ready for', iframeId);
          
          // Set the viewer background to transparent
          api.setBackground({ transparent: true }, function () {
            console.log("Background changed to transparent for", iframeId);
          });
          
          // Standard camera positions from your logs
          var cameraPosition = [-2.123642009323358e-8, -3.653240302148811, 1.5880760211155125];
          var cameraTarget = [-2.1236419622816527e-8, 0.0000024231290283172058, 0.401065504553163];
          
          // Set the camera position and target instantly (duration = 0)
          api.setCameraLookAt(cameraPosition, cameraTarget, 0, function(err) {
            if (!err) {
              console.log('Camera look at set for', iframeId);
              
              // Optionally, set the field of view (FOV) to 45 degrees
              api.setFieldOfView(45, 0, function(err) {
                if (!err) {
                  console.log('Field of view set to 45 for', iframeId);
                } else {
                  console.error('Error setting field of view for', iframeId);
                }
              });
            } else {
              console.error('Error setting camera look at for', iframeId);
            }
          });
        });
      } else {
        console.error("Sketchfab API error for", iframeId);
      }
    });
  });
});
